import { Box, styled } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { AssistantAvatarIcon } from '@/src/shared/assets/AssistantAvatarIcon';

import { ParagraphStyle } from '../styles';
import { CardPrefix } from './CardPrefix';

const OuterGrid = styled(Box)({
    display: 'grid',
    gridTemplateColumns: '32px 1fr',
    gap: '2px 8px',
    // to align with the input field, move the AvatarIcon left by 40px
    position: 'relative',
    left: '-40px',
    '@media (max-width: 767px)': {
        left: '-20px',
    },
});

const ContentBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',
    maxWidth: '80%',
    borderRadius: '6px',
    padding: theme.spacing(2, 4),
    backgroundColor: '#F5F5F5',
    '& > *': {
        overflowX: 'auto',
        ...ParagraphStyle,
    },
    '@media (max-width: 767px)': {
        maxWidth: '100%',
    },
}));

export const AssistantLikeCardLayout = ({
    children,
    timestamp,
}: PropsWithChildren<{ timestamp: string }>) => {
    const { t } = useTranslation('common');

    return (
        <OuterGrid className="chat-flow-card">
            <div></div>
            <CardPrefix timestamp={timestamp} nickname={t('app_name')} />
            <AssistantAvatarIcon />
            <ContentBox>{children}</ContentBox>
        </OuterGrid>
    );
};
